////////LIBRARY/////////
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
///////COMPONENTS///////
import theme from '../../theme/theme'
/////////ASSETS/////////
import Calendar from '../../assets/icones/global/calendar.svg'

/////////STYLED/////////
const CalendarInputInlineWrapper = styled.div`
	display: flex;
	width: ${(props) => (props.noDisplayValue ? 'auto' : '200px')};
`
const ImgContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: ${(props) => (props.noDisplayValue ? '4px' : '4px 0 0 4px')};
	background-color: ${(props) => (props.disabled ? props.theme.colors.eraser : props.theme.colors.primary)};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: ${(props) => (props.disabled ? 'not-allowed ' : 'pointer')};
	:hover {
		background-color: ${(props) => !props.disabled && props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const ImageStyle = styled.img`
	max-width: 20px;
	min-width: 20px;
`
const InputWrapper = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
`
const InputCalendar = styled.input`
	width: ${(props) => (props.width ? `${props.width}px` : '194px')};
	border-radius: 0 3px 3px 0;
	border: 1px solid ${(props) => props.theme.colors.table.borderTable};
	padding-left: 13px;
	box-sizing: border-box;
	color: ${(props) => props.theme.colors.menu.link};
	background-color: ${(props) => (props.disabled ? props.theme.colors.whiteGrey : props.theme.colors.white)};
	font-size: ${(props) => props.theme.font.fs};
	line-height: 28px;
`
/////////STYLED/////////

const CalendarInputInline = (props) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<CalendarInputInlineWrapper noDisplayValue={props.noDisplayValue}>
			<InputWrapper>
				<ImgContainer onClick={!props.disabled ? props.onClickHandler : null} noDisplayValue={props.noDisplayValue} disabled={props.disabled}>
					<ImageStyle src={Calendar} />
				</ImgContainer>
				{!props.noDisplayValue && (
					<InputCalendar
						width={props.width}
						type="text"
						readOnly={true}
						value={props.valueInput}
						name={props.name}
						disabled={props.disabled}
					/>
				)}
			</InputWrapper>
		</CalendarInputInlineWrapper>
	)
}

CalendarInputInline.propTypes = {
	color: PropTypes.string,
}

CalendarInputInline.defaultPropTypes = {
	color: theme.colors.primary,
}

export default CalendarInputInline
